import { useEffect, useRef, useState } from 'react';

export function useParallax() {
  const [offset, setOffset] = useState(0);
  const [isIOS, setIsIOS] = useState(false);

  const rafRef = useRef<number>(0);
  const currentOffset = useRef(0);

  useEffect(() => {
    const ios =
      /iphone|ipad|ipod/i.test(navigator.userAgent) ||
      (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);

    setIsIOS(ios);

    if (!ios) return;

    const lerp = (start: number, end: number, factor: number) =>
      start + (end - start) * factor;

    const maxOffset = 60; // ограничение (важно!)

    const animate = () => {
      // ✅ фикс отрицательного scroll (iOS bounce)
      const scrollY = Math.max(0, window.scrollY);

      // ✅ ограничение значения
      const target = Math.min(scrollY * 0.1, maxOffset);

      // ✅ плавность
      currentOffset.current = lerp(currentOffset.current, target, 0.08);

      setOffset(currentOffset.current);

      rafRef.current = requestAnimationFrame(animate);
    };

    rafRef.current = requestAnimationFrame(animate);

    return () => {
      cancelAnimationFrame(rafRef.current);
    };
  }, []);

  return { offset, isIOS };
}
